"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCouponLogPageList = getCouponLogPageList;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 券发放列表分页查询
function getCouponLogPageList(params) {
  return (0, _requestAuth.default)({
    url: '/xyCouponLog/page',
    method: 'get',
    params: params
  });
}